const PRIORITY_ORDER = {
  urgent: 4,
  high: 3,
  medium: 2,
  low: 1,
  none: 0,
};

export const isConversationAvailableForManualAssignment = conversation => {
  const customAttributes = conversation?.custom_attributes || {};

  return Boolean(
    conversation?.id &&
      conversation.status === 'open' &&
      !conversation.meta?.assignee &&
      !customAttributes.active_lumerai_flow_id &&
      customAttributes.ai_autopilot_status !== 'active'
  );
};

const waitingSince = conversation =>
  Number(
    conversation.waiting_since ||
      conversation.created_at ||
      conversation.last_activity_at ||
      Number.MAX_SAFE_INTEGER
  );

export const rankAssignmentCandidates = conversations =>
  [...(conversations || [])]
    .filter(isConversationAvailableForManualAssignment)
    .sort((first, second) => {
      const firstMissedSla = first.sla_missed_events?.length ? 1 : 0;
      const secondMissedSla = second.sla_missed_events?.length ? 1 : 0;
      if (firstMissedSla !== secondMissedSla) {
        return secondMissedSla - firstMissedSla;
      }

      const firstPriority = PRIORITY_ORDER[first.priority || 'none'] || 0;
      const secondPriority = PRIORITY_ORDER[second.priority || 'none'] || 0;
      if (firstPriority !== secondPriority) {
        return secondPriority - firstPriority;
      }

      return waitingSince(first) - waitingSince(second);
    });

export const getConversationContactName = conversation =>
  conversation?.meta?.sender?.name ||
  conversation?.meta?.sender?.available_name ||
  conversation?.meta?.sender?.email ||
  'contato sem nome';

export const isEditableElement = element =>
  Boolean(
    element?.matches?.(
      'input, textarea, select, [contenteditable="true"], [role="textbox"]'
    )
  );
